import { BrandLogo } from '../BrandLogo';

import { useTenantBranding } from '~hooks/tenant/useTenantBranding';

/**
 * @deprecated Use `NavbarViewV1` - with FF `CONFIGURABLE_WEB_APP_BANNER` instead.
 * @deprecationReason To support custom navbar and release web app banner feature
 */
export const NavbarView: React.FC = () => {
  const { logoUrl, displayName } = useTenantBranding();

  return (
    <>
      <BrandLogo
        src={logoUrl}
        name={displayName}
        maxWidth={130}
        maxHeight={40}
      />
    </>
  );
};
